import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="m4.159 13.333 2.288-2.91a1.667 1.667 0 0 1 2.575-.057l2.011 2.342m-1.737-2.022a509.68 509.68 0 0 0 2.147-2.759l.008-.01a1.667 1.667 0 0 1 2.57-.05l2.012 2.341M5.825 16.042h8.75c.92 0 1.667-.747 1.667-1.667v-8.75c0-.92-.746-1.667-1.667-1.667h-8.75c-.92 0-1.666.747-1.666 1.667v8.75c0 .92.746 1.667 1.666 1.667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);